module.exports = __webpack_public_path__ + "img/2.3_Associate-Investigators_2_Ella.b18433d82e12341580a233ea9ba6a734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.3_Associate-Investigators_2_Ella.png
// module id = 758
// module chunks = 0